export default {
    props: {
        size: {
            type: [String, Number],
            default: null
        },

        xxSmall: {
            type: Boolean,
            default: false
        },

        xSmall: {
            type: Boolean,
            default: false
        },

        small: {
            type: Boolean,
            default: false
        },

        medium: {
            type: Boolean,
            default: false
        },

        large: {
            type: Boolean,
            default: false
        },

        xLarge: {
            type: Boolean,
            default: false
        },

        xxLarge: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        sizeString() {
            if (this.xxSmall || this.size === '2xs') {
                return '2xs';
            }

            if (this.xSmall || this.size === 'xs') {
                return 'xs';
            }

            if (this.small || this.size === 'sm') {
                return 'sm';
            }

            if (this.medium || this.size === 'md') {
                return 'md';
            }

            if (this.large || this.size === 'lg') {
                return 'lg';
            }

            if (this.xLarge || this.size === 'xl') {
                return 'xl';
            }

            if (this.xxLarge || this.size === '2xl') {
                return '2xl';
            }

            return null;
        }
    }
}
